import './single.scss';

if ($(".swiper-container").length) {
  var swiper = new Swiper('.swiper-container', { // eslint-disable-line
    loop: false,
    speed: 600,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

// additional info slider
if ($(".info-columns__swiper").length) {
  (function() {
    // breakpoint where swiper will be destroyed
    var breakpoint = window.matchMedia( '(min-width:768px)' );
    // keep track of swiper instances to destroy later
    var swiperInfo; // eslint-disable-line
    var breakpointChecker = function() {
      // if larger viewport and multi-row layout needed
      if ( breakpoint.matches === true ) {
        // clean up old instances and inline styles when available
      if ( swiperInfo !== undefined ) swiperInfo.destroy( true, true );
      // or/and do nothing
      return;
        // else if a small viewport and single column layout needed
        } else if ( breakpoint.matches === false ) {
          // fire small viewport version of swiper
          return enableSwiper();
        }
    };

    var enableSwiper = function() {
      swiperInfo = new Swiper('.info-columns__swiper', { // eslint-disable-line
        wrapperClass: "info-columns__grid",
        slideClass: "info-columns__item",
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true,
        speed: 600,
      });
    };
    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })();
}
// eof additional info slider





// WEBPACK FOOTER //
// ./resources/views/partials/products_type/single/single.js